// The background plugin
// import background, { ModeEnum } from '@react-page/plugins-background';
// import css as well. currently, we caannot do this here in the demo project and have moved that to _app.tsx
// see https://github.com/vercel/next.js/issues/19717
// import '@react-page/plugins-background/lib/index.css';

import bunkeringProcedurePlugin from './bunkeringElementPlugin';
import columnsTablePlugin from './columnsTablePlugin';
import emergencyBox1ContentPlugin from './EmergencyScreen/emergencyBox1ContentPlugin';
import emergencyBox1Plugin from './EmergencyScreen/emergencyBox1Plugin';
import emergencyBox2Plugin from './EmergencyScreen/emergencyBox2Plugin';
import emergencyElemTitlePlugin from './EmergencyScreen/emergencyElemTitlePlugin';
import emergencyScreenLayoutPlugin from './EmergencyScreen/emergencyScreenLayoutPlugin';
import environmentalWarningPlugin from './environmentalWarning';
import feedBackBlockController from './FeedbackPlugin/feedBackBlockController';
import furtherInfoPlugin from './furtherInfoPlugin';
import heightSpacePlugin from './heightSpacePlugin';
import horizontalLinePlugin from './horizontalLinePlugin';
import iconBlockPluginController from './IconBlockPlugin/iconBlockPluginController';
import jobSafetyPluginController from './JobSafetyPlugin/jobSafetyPluginController';
import linkBlockPlugin from './LinkBlock/linkBlockPlugin';
import navigationElementPlugin from './navigationElementPlugin';
import numberedSectionPlugin from './numberedSection';
import numberedSubSectionPlugin from './numberedSubSectionPlugin';
import pyramidPlugin from './Pyramid/pyramidPlugin';
import rankPortalListPlugin from './RankPortal/rankPortalListPlugin';
import leftMenuPlugin from './SideMenu/leftMenuPlugin';
import sidebarLinkPlugin from './SideMenu/sidebarLinkPlugin ';
import { customizedSlate, defaultSlate } from './slate';
import titlePlugin from './titlePlugin';
import warningPlugin from './warningPlugin';
import widthContainer from './widthContainer';

// Define which plugins we want to use.

export const cellPlugins = [
  defaultSlate,
  customizedSlate,
  // spacer,
  // video,
  // divider,
  // html5video,
  // customContentPlugin,
  // customContentPluginWithListField,
  // customContentPluginTwitter,
  // codeSnippet,
  // contactForm,

  // background({
  //   imageUpload: fakeImageUploadService('/images/sea-bg.jpg'),
  //   enabledModes:
  //     ModeEnum.COLOR_MODE_FLAG |
  //     ModeEnum.IMAGE_MODE_FLAG |
  //     ModeEnum.GRADIENT_MODE_FLAG,
  // }),
  // customLayoutPlugin,
  // customLayoutPluginWithInitialState,
];

export const customOrder = ({
  backgroundPlugin,
  imagePlugin,
  rankPortalTextEditorPlugin,
  draggablePlugin,
}: any) => [
  defaultSlate,
  customizedSlate,
  backgroundPlugin,
  heightSpacePlugin,
  widthContainer,
  imagePlugin,
  iconBlockPluginController,
  horizontalLinePlugin,
  navigationElementPlugin,
  titlePlugin,
  feedBackBlockController,
  emergencyElemTitlePlugin,
  linkBlockPlugin,
  emergencyBox1ContentPlugin,
  rankPortalTextEditorPlugin,
  sidebarLinkPlugin,
  bunkeringProcedurePlugin,
  jobSafetyPluginController,
  emergencyBox2Plugin,
  warningPlugin,
  environmentalWarningPlugin,
  furtherInfoPlugin,
  rankPortalListPlugin,
  columnsTablePlugin,
  pyramidPlugin,
  draggablePlugin,
  numberedSectionPlugin,
  numberedSubSectionPlugin,
  leftMenuPlugin,
  emergencyScreenLayoutPlugin,
  emergencyBox1Plugin,
];

export const emergencyScreenPlugins = [
  emergencyScreenLayoutPlugin,
  emergencyBox1Plugin,
  emergencyElemTitlePlugin,
  emergencyBox1ContentPlugin,
  emergencyBox2Plugin,
];
export const generalPlugins = [
  heightSpacePlugin,
  titlePlugin,
  warningPlugin,
  environmentalWarningPlugin,
  // notePlugin,
  furtherInfoPlugin,
  bunkeringProcedurePlugin,
  // navigationElementPlugin,
  pyramidPlugin,
  linkBlockPlugin,
  feedBackBlockController,
  jobSafetyPluginController,
  iconBlockPluginController,
  horizontalLinePlugin,
  rankPortalListPlugin,
  numberedSubSectionPlugin,
  numberedSectionPlugin,
  // sectionsContainer,
  widthContainer,
  // rankPortalTitle,
  leftMenuPlugin,
  sidebarLinkPlugin,
];
